export default function (userInputs, labels, store) {
    const basket = []
    let label = ''

    const donationFor = store.state.donation.donationFor

    const donationAmount = userInputs.find((item) => item.name === 'amount')

    switch (donationFor) {
        case 'team':
            label = labels.yourInformationTotalDonationHold
            break
        case 'participant':
            label = labels.yourInformationTotalDonationDeltager
            break
        case 'stafet':
            label = labels.yourInformationTotalDonationStafet
            break
        default:
            label = labels.yourInformationTotalDonationStafet
            break
    }

    basket.push({
        label: label,
        amount: '',
        price: `${donationAmount ? donationAmount.value : 0} kr.`,
        intPrice: donationAmount.value
    })

    store.dispatch('donation/basket', { basket: basket })
}
